import { createContext, useContext } from 'react';
import { DEFAULT_CATEGORY } from '../consts';
import { DevicePreview } from '../types';
import noop from 'utils/noop';

export interface DevicePreviewContextState {
  devicePreviews: DevicePreview[];
  isLoading: boolean;
  categoriesCount: Record<string, number>;
  refetch: () => void;
  isEnabled: boolean;
  isTemplateError: boolean;
  templateName?: string;
}

export const DevicePreviewContextDefaults = {
  devicePreviews: [],
  isLoading: true,
  categoriesCount: {
    [DEFAULT_CATEGORY]: 0,
  },
  refetch: noop,
  isEnabled: true,
  isTemplateError: false,
};

export const DevicePreviewContext = createContext<DevicePreviewContextState>(
  DevicePreviewContextDefaults,
);

export const useDevicePreviewContext = () => useContext(DevicePreviewContext);
